import React from 'react';
import MfaSettings from 'components/MfaSettings/MfaSettings';

const MfaPage = () => {
  return <MfaSettings />;
};

export default MfaPage;
